// extracted by mini-css-extract-plugin
export var container = "_s5-0";
export var dotAnimation = "_s5-2";
export var dotsLoading = "_s5-1";